var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": !_vm.dataForm.id ? 'Add User' : 'Edit User',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "900px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.laoding,
      expression: "laoding"
    }]
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nickname",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nick name",
      "disabled": ""
    },
    model: {
      value: _vm.dataForm.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "nickname", $$v);
      },
      expression: "dataForm.nickname"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Roles",
      "size": "mini",
      "prop": "roleIdList"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: _vm.dataForm.roleIdList,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "roleIdList", $$v);
      },
      expression: "dataForm.roleIdList"
    }
  }, _vm._l(_vm.roleList, function (role) {
    return _c('el-checkbox', {
      key: role.id,
      attrs: {
        "label": role.id
      }
    }, [_vm._v(_vm._s(role.name))]);
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierIdList"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": ""
    },
    model: {
      value: _vm.dataForm.supplierIdList,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierIdList", $$v);
      },
      expression: "dataForm.supplierIdList"
    }
  }, _vm._l(_vm.allSupplierList, function (item) {
    return _c('el-option', {
      key: "supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1), _c('div', {
    staticClass: "lh20 fs12 black88"
  }, [_vm._v("When empty, default to having all supplier permissions")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Assign To",
      "prop": "replacementUser"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.replacementUserChange
    },
    model: {
      value: _vm.dataForm.replacementUserId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "replacementUserId", $$v);
      },
      expression: "dataForm.replacementUserId"
    }
  }, _vm._l(_vm.sysUserList, function (item) {
    return _c('el-option', {
      key: "sys-user-".concat(item.id),
      attrs: {
        "label": item.nickname,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Assign Supplier",
      "prop": "replacementUserSupplierIdList"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": ""
    },
    model: {
      value: _vm.dataForm.replacementUserSupplierIdList,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "replacementUserSupplierIdList", $$v);
      },
      expression: "dataForm.replacementUserSupplierIdList"
    }
  }, _vm._l(_vm.allSupplierList, function (item) {
    return _c('el-option', {
      key: "replacement-supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.laoding,
      expression: "laoding"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "element-loading-custom-class": "dialog-loading-hide"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit();
      }
    }
  }, [_vm._v("OK")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }